import { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'gene... Remove this comment to see the full error message
import { useStoreDependency } from 'general-store';
import { AnyCrmObjectTypePropType, AnyCrmObjectPropType
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
} from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import CrmObjectRecord from 'customer-data-objects/crmObject/CrmObjectRecord';
import { DEAL } from 'customer-data-objects/constants/ObjectTypes';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { List, Map as ImmutableMap } from 'immutable';
import { Tabs, Tab } from 'foundations-components/transitional/components/Tabs';
import AssociatedDealRegIdsStore from 'partner-shared-view-ui/flux/AssociatedDealRegIdsStore';
import DealRegistrationCrmObjectStore from 'partner-shared-view-ui/flux/DealRegistrationCrmObjectStore';
import { isLoading, isEmpty, LOADING, EMPTY
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
} from 'crm_data/flux/LoadingStatus';
import { canRenderBETContactSummaryTab, canRenderBETCustomerSummaryTab, canRenderBETRenewalSummaryTab, canRenderBETPartnerSharedActivitiesTab, canRenderBETCallSummaryTab } from 'crm-events-components/internal/BET/permissions/helpers/BETTimelinePermissionsUtils';
import { BET_CONTACT_SUMMARY_TAB, BET_CUSTOMER_SUMMARY_TAB, BET_RENEWAL_SUMMARY_TAB, PARTNER_SHARED_ACTIVITIES_TAB, CALL_SUMMARY_TAB } from 'crm-events-components/internal/BET/timeline/constants/BETTimelineConstants';
import ContactSummaryContainerAsync from 'crm-events-components/internal/BET/timeline/ContactSummaryContainerAsync';
import CustomerSummaryContainerAsync from 'crm-events-components/internal/BET/timeline/CustomerSummaryContainerAsync';
import PartnerSharedActivitiesTab from 'crm-events-components/internal/BET/timeline/PartnerSharedActivitiesTab';
import RenewalSummaryContainerAsync from 'crm-events-components/internal/BET/timeline/RenewalSummaryContainerAsync';
import CallSummaryContainerAsync from 'crm-events-components/internal/BET/timeline/CallSummaryContainerAsync';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useIsUngated, useSubjectContext } from 'crm-events-data';
import { useFetchTimelineFilters, getSelectedFilters, ENGAGEMENT_TYPE_TO_I18N_KEY, TimelineFiltersStore, useTimelineActionHandlerContext, OPEN_ACTIVITY_QUICK_VIEW_MODAL, OPEN_PORTAL_USERS_PANEL, TimelineActions } from 'crm-events-data';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { gate } from 'hub-http/gates';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TIMELINE_FILTER_ENGAGEMENT_TYPES = {
  ENGAGEMENTS_ACTIVITY: 'ENGAGEMENTS_ACTIVITY',
  ENGAGEMENTS_NOTES: 'ENGAGEMENTS_NOTES',
  ENGAGEMENTS_EMAILS_TRIMMED: 'ENGAGEMENTS_EMAILS_TRIMMED',
  ENGAGEMENTS_CALLS: 'ENGAGEMENTS_CALLS',
  ENGAGEMENTS_TASKS: 'ENGAGEMENTS_TASKS',
  ENGAGEMENTS_MEETINGS: 'ENGAGEMENTS_MEETINGS'
};
const TIMELINE_TABS_TRANSLATION_KEYS = {
  activity: 'timeline.filters.tabTitles.activity',
  calls: 'timeline.filters.tabTitles.calls',
  emails: 'timeline.filters.tabTitles.emails',
  meetings: 'timeline.filters.tabTitles.meetings',
  notes: 'timeline.filters.tabTitles.notes',
  tasks: 'timeline.filters.tabTitles.tasks'
};
const BET_TABS = [BET_CONTACT_SUMMARY_TAB, BET_CUSTOMER_SUMMARY_TAB, BET_RENEWAL_SUMMARY_TAB, PARTNER_SHARED_ACTIVITIES_TAB, CALL_SUMMARY_TAB];
const isBetTab = tabType => BET_TABS.includes(tabType);
const NewTabBadge = () => {
  return /*#__PURE__*/_jsx(Badge, {
    use: "new",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "timeline.filters.tabTitles.newTabBadge"
    })
  });
};
const propTypes = {
  defaultSelected: PropTypes.string.isRequired,
  objectType: AnyCrmObjectTypePropType.isRequired,
  onTabClick: PropTypes.func.isRequired,
  selected: PropTypes.string.isRequired,
  subject: AnyCrmObjectPropType,
  scopes: PropTypes.arrayOf(PropTypes.string)
};
const logUsage = type => {
  if (!isBetTab(type)) {
    CrmLogger.log('timelineInteractions', {
      action: 'switch timeline tabs',
      activity: type
    });
  } else {
    CrmLogger.log('timelineInteractions', {
      action: 'switch BET timeline tabs',
      activity: type
    });
  }
};
export const dependencies = {
  allFilters: {
    stores: [TimelineFiltersStore],
    deref: ({
      objectType
    }) => {
      return TimelineFiltersStore.get(objectType);
    }
  },
  dealRegistrations: {
    stores: [AssociatedDealRegIdsStore, DealRegistrationCrmObjectStore],
    deref: ({
      objectType,
      subject,
      scopes
    }) => {
      const isScoped = scopes.includes('partner-shared-view-internal-access') || scopes.includes('partner-deal-registration-read');
      if (objectType !== DEAL || !subject || !isScoped) {
        return EMPTY;
      }
      const associatedIdsBatch = AssociatedDealRegIdsStore.get([subject.get('dealId')]);
      const associatedIds = associatedIdsBatch[0];
      if (isLoading(associatedIds) || isEmpty(associatedIds)) {
        return associatedIds;
      }
      const ids = associatedIds.results.map(response => response.objectId);
      const crmObjects = DealRegistrationCrmObjectStore.get(ids);
      if (crmObjects.some(crmObj => isLoading(crmObj))) {
        return LOADING;
      } else if (crmObjects.some(crmObj => isEmpty(crmObj))) {
        return EMPTY;
      } else {
        return List(crmObjects.map(CrmObjectRecord.fromJS));
      }
    }
  }
};
function TimelineTabsV2({
  defaultSelected,
  objectType,
  onTabClick,
  selected,
  subject,
  scopes
}) {
  const {
    subjectId
  } = useSubjectContext();
  const isUngated = useIsUngated();
  const isUngatedForLeadSummary = isUngated(gate('CAPMAN:LeadSummaryWithNon-QL'));
  const allFilters = useStoreDependency(dependencies.allFilters, {
    objectType
  });
  const {
    data: filtersData
  } = useFetchTimelineFilters({
    subjectId,
    objectTypeOrId: objectType
  });
  const filterGroups = !filtersData ? [] : filtersData.crmObject.timeline.filterGroups;
  const selectedEventFilters = getSelectedFilters(filterGroups);
  const dealRegistrations = useStoreDependency(dependencies.dealRegistrations, {
    objectType,
    subject,
    scopes
  });
  const handleTimelineAction = useTimelineActionHandlerContext();
  const [BETDidCloseYourDealModalShow, setBETDidCloseYourDealModalShow] = useState(false);
  const handleBETCloseYourDealModalShown = useCallback(() => {
    setBETDidCloseYourDealModalShow(true);
  }, []);
  const handleTabClick = useCallback(type => {
    if (type === selected) {
      return null;
    }
    logUsage(type);
    onTabClick(type);
    const requestPayloadDefaults = {
      objectType,
      subjectId,
      selectedTeams: List(),
      selectedOwners: List()
    };
    if (type === TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_ACTIVITY) {
      const allActivitiesRequestPayload = ImmutableMap(Object.assign({}, requestPayloadDefaults, {
        eventOptions: selectedEventFilters,
        searchText: allFilters ? allFilters.get('searchText') : ''
      }));
      TimelineActions.clearFavoriteEventOverride(objectType);
      return TimelineActions.updateTimelineUserAndTeamFilters(objectType, allActivitiesRequestPayload);
    }
    const searchText = !isBetTab(type) && allFilters ? allFilters.get('searchText') : '';
    const specificEngagementRequestPayload = ImmutableMap(Object.assign({}, requestPayloadDefaults, {
      eventOptions: List([type]),
      searchText
    }));
    TimelineActions.changeTimelineFiltersInStore(objectType, ImmutableMap({
      selectedTeams: List(),
      selectedOwners: List(),
      searchText
    }));
    return TimelineActions.overrideFavoriteEvent(objectType, List([type]), specificEngagementRequestPayload);
  }, [allFilters, objectType, onTabClick, selected, selectedEventFilters, subjectId]);
  const renderTab = useCallback((i18nkey, type) => {
    return /*#__PURE__*/_jsx(Tab, {
      "data-onboarding": `timeline-tab-filter-${i18nkey}`,
      "data-selenium-test": `timeline-tab-filter-${i18nkey}`,
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      onClick: (...args) => handleTabClick(type, ...args),
      tabId: type,
      title: /*#__PURE__*/_jsx(FormattedHTMLMessage
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      , {
        message: TIMELINE_TABS_TRANSLATION_KEYS[i18nkey]
      }),
      paddingInline: "250"
    }, type);
  }, [handleTabClick]);
  const handleRenderTab = useCallback(type => {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const i18nkey = ENGAGEMENT_TYPE_TO_I18N_KEY[type];
    return renderTab(i18nkey, type);
  }, [renderTab]);
  const handleOpenActivityQuickViewModal = useCallback(data => {
    handleTimelineAction(OPEN_ACTIVITY_QUICK_VIEW_MODAL, data);
  }, [handleTimelineAction]);
  const handleOpenPortalUsersPanel = useCallback(data => {
    handleTimelineAction(OPEN_PORTAL_USERS_PANEL, data);
  }, [handleTimelineAction]);
  const renderBETTab = useCallback(({
    tab
  }) => {
    const permissionGranted = tab.permissionsCheck({
      objectType,
      scopes,
      subject,
      dealRegistrations
    });
    if (!permissionGranted) return null;
    return /*#__PURE__*/_jsxs(Tab, {
      "data-onboarding": tab.filter,
      "data-selenium-test": tab.filter,
      onClick: (...args) =>
      // @ts-expect-error ts-migrate(2556) FIXME: A spread argument must either have a tuple type or... Remove this comment to see the full error message
      handleTabClick(tab.type, ...args),
      tabId: tab.type,
      title: tab.type === CALL_SUMMARY_TAB ? /*#__PURE__*/_jsxs(Flex, {
        gap: "100",
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: tab.title
        }), /*#__PURE__*/_jsx(NewTabBadge, {})]
      }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: tab.title
      }),
      paddingInline: "250",
      children: [tab.type === BET_CONTACT_SUMMARY_TAB ? /*#__PURE__*/_jsx(ContactSummaryContainerAsync, {
        contact: subject
      }) : null, tab.type === BET_RENEWAL_SUMMARY_TAB ? /*#__PURE__*/_jsx(RenewalSummaryContainerAsync, {
        deal: subject,
        handleOpenActivityQuickViewModal: handleOpenActivityQuickViewModal,
        handleOpenPortalUsersPanel: handleOpenPortalUsersPanel,
        logTrackingEvent: CrmLogger.logForBizOps
      }) : null, tab.type === BET_CUSTOMER_SUMMARY_TAB ? /*#__PURE__*/_jsx(CustomerSummaryContainerAsync, {
        didCloseYourDealModalShow: BETDidCloseYourDealModalShow,
        handleCloseYourDealModal: handleBETCloseYourDealModalShown,
        handleOpenActivityQuickViewModal: handleOpenActivityQuickViewModal,
        handleOpenPortalUsersPanel: handleOpenPortalUsersPanel,
        logTrackingEvent: CrmLogger.logForBizOps,
        objectType: objectType,
        subject: subject
      }) : null, tab.type === PARTNER_SHARED_ACTIVITIES_TAB ? /*#__PURE__*/_jsx(PartnerSharedActivitiesTab, {
        objectType: objectType,
        scopes: scopes,
        subject: subject
      }) : null, tab.type === CALL_SUMMARY_TAB ? /*#__PURE__*/_jsx(CallSummaryContainerAsync, {
        objectTypeId: objectType,
        objectId: subjectId
      }) : null]
    }, tab.type);
  }, [BETDidCloseYourDealModalShow, dealRegistrations, handleBETCloseYourDealModalShown, handleOpenActivityQuickViewModal, handleOpenPortalUsersPanel, handleTabClick, objectType, scopes, subject, subjectId]);
  return /*#__PURE__*/_jsxs(Tabs, {
    defaultSelected: defaultSelected,
    selected: selected,
    panelStyles: {
      paddingInline: '0'
    },
    children: [renderBETTab({
      tab: {
        type: BET_CONTACT_SUMMARY_TAB,
        permissionsCheck: canRenderBETContactSummaryTab,
        filter: 'timeline-tab-filter-contactSummary',
        title: isUngatedForLeadSummary ? 'timeline.filters.tabTitles.leadSummary' : 'timeline.filters.tabTitles.contactSummary'
      }
    }), renderBETTab({
      tab: {
        type: BET_RENEWAL_SUMMARY_TAB,
        permissionsCheck: canRenderBETRenewalSummaryTab,
        filter: 'timeline-tab-filter-renewalSummary',
        title: 'timeline.filters.tabTitles.renewalSummary'
      }
    }), renderBETTab({
      tab: {
        type: BET_CUSTOMER_SUMMARY_TAB,
        permissionsCheck: canRenderBETCustomerSummaryTab,
        filter: 'timeline-tab-filter-customerSummary',
        title: 'timeline.filters.tabTitles.customerSummary'
      }
    }), renderBETTab({
      tab: {
        type: PARTNER_SHARED_ACTIVITIES_TAB,
        permissionsCheck: canRenderBETPartnerSharedActivitiesTab,
        filter: 'timeline-tab-filter-partnerSharedActivities',
        title: 'timeline.filters.tabTitles.partnerSharedActivities'
      }
    }), renderBETTab({
      tab: {
        type: CALL_SUMMARY_TAB,
        permissionsCheck: canRenderBETCallSummaryTab,
        filter: 'timeline-tab-filter-callSummary',
        title: 'timeline.filters.tabTitles.callSummary'
      }
    }), handleRenderTab(TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_ACTIVITY), handleRenderTab(TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_NOTES), handleRenderTab(TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_EMAILS_TRIMMED), handleRenderTab(TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_CALLS), handleRenderTab(TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_TASKS), handleRenderTab(TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_MEETINGS)]
  });
}
TimelineTabsV2.propTypes = propTypes;
export default TimelineTabsV2;